let baseUrl = "#{Licensing.Registration.Api.Url}";

function getBase() {
  if (baseUrl.indexOf("Licensing.Registration.Api.Url") > -1) {
    baseUrl = "https://eprapielevate-stg.nvidia.com/";
  }
  return baseUrl;
}

export const UCJ_INITIALIZE    = () => getBase() + "api/ucj/initialize";
export const UCJ_USER_PROFILE  = () => getBase() + "api/ucj/user-profile";
export const UCJ_REGISTER      = () => getBase() + "api/ucj/register";
export const UCJ_STATUS        = (id) => getBase() + `api/ucj/status/${id}`;
